import Biohazard from './biohazard.svg'
import Corrosive from './corrosive.svg'
import DangerousWhenWet from './dangerous-when-wet.svg'
import Explosive from './explosive.svg'
import FlammableGas from './flammable-gas.svg'
import FlammableLiquids from './flammable-liquids.svg'
import FlammableSolids from './flammable-solids.svg'
import FlammableSolidsCombustible from './flammable-solids-combustible.svg'
import Misc from './misc.svg'
import NonFlammableGas from './non-flammable-gas.svg'
import Oxidizing from './oxidizing.svg'
import RadioActive from './radioactive.svg'
import Toxic from './toxic.svg'
import ToxicGas from './toxic-gas.svg'

export const dangerousSVGs = {
  '1': Explosive,
  '2.1': FlammableGas,
  '2.2': NonFlammableGas,
  '2.3': ToxicGas,
  '3': FlammableLiquids,
  '4.1': FlammableSolids,
  '4.2': FlammableSolidsCombustible,
  '4.3': DangerousWhenWet,
  '5.1': Oxidizing,
  '6.1': Toxic,
  '6.2': Biohazard,
  '7': RadioActive,
  '8': Corrosive,
  '9': Misc,
} as const
